import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useStockPrice(symbol: string, exchange?: string) {
  return useQuery({
    queryKey: ['stock-price', symbol, exchange],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('stock-price', {
        body: { symbol, exchange },
      });
      if (error) throw error;
      return data as { price: number; change: number; changePercent: number; currency: string } | null;
    },
    enabled: !!symbol,
    staleTime: 5 * 60 * 1000, // 5 min cache
    // Retry up to 3 times with exponential backoff (1s, 2s, 4s).
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * Math.pow(2, attempt), 30000),
  });
}
